import React from 'react';

import * as eventsApi from '../../../api/eventsApi';
import AnswerOptionItem from './answerOptionItem/answerOptionItem';
import { SIMPLE_SELECT } from '../../../util/answerOptionTypes';

import './answerOptionIndex.scss';

class AnswerOptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pollOptionIdSelected: null,
            voteCounts: {}
        }

        this.selectionState = this.selectionState.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.toggleDisplay = this.toggleDisplay.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { pollVotes } = this.props;

        if (pollVotes !== prevProps.pollVotes) {
            this.setState({
                voteCounts: pollVotes
            });
        }
    }

    handleClick(pollOption) {
        const pollOptionId = pollOption.id;
        const newVoteCountsState = {...this.state.voteCounts};

        const { pollInfo, inlineParentMetadata, appType } = this.props;

        //If first selection, add user's vote to count
        if (!this.state.pollOptionIdSelected) {
            newVoteCountsState[pollOptionId] += 1;
        }

        this.setState({
            pollOptionIdSelected: pollOptionId,
            voteCounts: newVoteCountsState
        })

        const eventOptions = { 
            inlineParentMetadata,
            appType,
            questionId: 0, //Each poll should only ever have 1 question
            answerType: SIMPLE_SELECT
        }
        
        eventsApi.answerSelected(pollOption.text, pollInfo.question, pollInfo, eventOptions);

        this.props.handleSelect(pollOptionId);
    }

    selectionState(pollOptionId) {
        if (pollOptionId === this.state.pollOptionIdSelected) {
            return 'selected';
        } else if (this.state.pollOptionIdSelected || this.props.showResults) {
            return 'unselected';
        }

        return 'default';
    }

    votePercentages() {
        const pollVotes = {...this.state.voteCounts};

        if (pollVotes) {
            const totalVoteCount = Object.values(pollVotes).reduce((a, b) => a + b, 0);

            for (const pollOptionId in pollVotes) {
                const voteCount = pollVotes[pollOptionId];
                const percentage = (voteCount / totalVoteCount) * 100;

                pollVotes[pollOptionId] = Math.round(percentage);
            }
        }

        return pollVotes;
    }

    toggleDisplay() {
        return this.state.pollOptionIdSelected  || this.props.showResults ? 'show' : 'hide';
    }

    render() {
        const {
            options,
        } = this.props;

        const votePercentages = this.votePercentages();

        const optionItems = options ? options.map((option, idx) => (
            <AnswerOptionItem 
                key={idx}
                votePercentage={votePercentages[option.id]}
                pollOption={option}
                toggleDisplay={this.toggleDisplay}
                selectionState={this.selectionState}
                handleClick={this.handleClick}
            />
        )) : null;

        return (
            <ul className={`answers-container poll-answer ${this.props.pollInfo.site}`}>
                {optionItems}
            </ul>
        )
    }

}


export default AnswerOptions;